import { useFeatureFlagEnabled } from "@posthog/react";

const NO_FLAG_SENTINEL = "__no_activity_flag__";

export function useActivityFlagEnabled(flag: string | undefined): boolean {
  const flagEnabled = useFeatureFlagEnabled(flag ?? NO_FLAG_SENTINEL);
  return !flag || flagEnabled === true;
}
